<template>
	<div class="products-filter" v-click-outside="hideDropDown">
		<span
			class="filter-button"
			:class="{
				active: isDropVisible || selectedFilterIndex !== 0
			}"
			@click="toggleDropDown"
		>
			filter
		</span>

		<div v-if="isDropVisible" class="drop">
			<div class="drop-title">Filter By</div>
			<ul class="drop-list">
				<li
					v-for="(filter, index) in productsFilterList"
					class="drop-item"
					:class="{ active: selectedFilterIndex === index }"
					:key="index"
					@click="selectFilter(filter, index)"
				>
					{{ filter.label }}
					<img
						v-if="filter.value === 'Trending'"
						:src="trendingIcon"
						class="drop-item-icon"
					/>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { clickOutside } from '../utils/helpers'
import { MENU_ARRANGEMENT_LIST, PRODUCTS_FILTER_LIST } from '../constants'
import TrendingIcon from '@/assets/images/ic_diamond.svg'

import { mapGetters } from 'vuex'

export default {
	name: 'ProductsFilter',

	directives: {
		'click-outside': clickOutside
	},

	data() {
		return {
			isDropVisible: false
		}
	},

	computed: {
		...mapGetters('productCatalog', [
			'isNewProductPresented',
			'isStaffFavoriteProductPresented'
		]),
		trendingIcon() {
			return TrendingIcon
		},

		productsFilterList() {
			return PRODUCTS_FILTER_LIST.filter(filterItem => {
				const value = filterItem.value
				return !(
					(value === 'new' && !this.isNewProductPresented) ||
					(value === 'favorite' && !this.isStaffFavoriteProductPresented)
				)
			})
		},

		selectedFilterIndex() {
			const currentFilter = this.$route.query.filter
			const currentTrendingValue = this.$route.query.trending

			if (currentTrendingValue && +currentTrendingValue === 1) {
				return this.productsFilterList.findIndex(
					filter => filter.value === MENU_ARRANGEMENT_LIST[1]
				)
			} else
				return this.productsFilterList.findIndex(
					filter => filter.value === currentFilter
				)
		}
	},

	methods: {
		showDropDown() {
			this.isDropVisible = true
		},

		hideDropDown() {
			this.isDropVisible = false
		},

		toggleDropDown() {
			this.isDropVisible ? this.hideDropDown() : this.showDropDown()
		},

		selectFilter(filter, index) {
			this.hideDropDown()

			if (this.selectedFilterIndex === index) return

			this.$router.push({
				...this.$route,
				query: {
					...this.$route.query,
					filter:
						filter.value === MENU_ARRANGEMENT_LIST[1] ? 'all' : filter.value,
					trending: filter.value === MENU_ARRANGEMENT_LIST[1] ? 1 : 0
				}
			})
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.products-filter {
	text-align: left;
	position: relative;
	z-index: 101;

	.drop {
		position: absolute;
		right: 0;
		top: 100%;
		width: 302px;
		margin: 14px 0 0;
		background: $background-popup;
		border-radius: 12px;
		border: 1px solid $border-color;
		padding: 10px 8px;

		@media (min-width: 640px) {
			padding: 17px 15px 15px;
		}

		@media (min-width: 768px) {
			width: 478px;
		}

		&:before {
			position: absolute;
			right: 15px;
			top: -5px;
			width: 12px;
			height: 12px;
			transform: rotate(45deg);
			background: $shadow-indigo;
			content: '';
			z-index: 2;
		}

		&:after {
			position: absolute;
			right: 14.9px;
			top: -6.8px;
			width: 13px;
			height: 13px;
			transform: rotate(45deg);
			background: $border-color;
			content: '';
			z-index: 1;
		}
	}

	.drop-title {
		color: $white;
		font-size: 16px;
		font-weight: 700;
		margin-bottom: 15px;

		@media (min-width: 640px) {
			margin-bottom: 33px;
		}
	}

	.drop-list {
		padding: 0;
		font-size: 16px;
		list-style: none;
	}

	.drop-item {
		display: flex;
		align-items: center;
		padding: 12px 8px;
		color: $white;
		border-radius: 10px;
		border: 1px solid $border-color;
		position: relative;
		background-color: rgba($light-violet, 0.2);
		transition: background-color 0.5s;
		text-transform: uppercase;
		cursor: pointer;

		@media (min-width: 640px) {
			padding: 17px 8px;
			font-size: 16px;
			border-radius: 12px;
		}

		&:not(:last-child) {
			margin-bottom: 8px;

			@media (min-width: 640px) {
				margin-bottom: 16px;
			}
		}

		&:hover {
			background-color: rgba($light-blue, 0.25);
		}

		&.active {
			cursor: default;
			border-color: $pink;

			&:hover {
				background-color: rgba($light-blue, 0.25);
			}

			&:after {
				display: block;
			}
		}

		&:after {
			position: absolute;
			right: 11px;
			top: 42%;
			width: 11px;
			height: 5px;
			border-style: solid;
			border-color: $white;
			border-width: 0 0 2px 2px;
			transform: rotate(-45deg) translateY(-50%);
			content: '';
			display: none;

			@media (min-width: 640px) {
				top: 46%;
				width: 13px;
				height: 6px;
			}
		}
	}

	.drop-item-icon {
		width: 14px;
		margin-left: 6px;

		@media (min-width: 640px) {
			width: 16px;
			margin-left: 8px;
		}
	}
}

.filter-button {
	display: block;
	width: 47px;
	height: 47px;
	background: url('../assets/images/ic_filters.svg') no-repeat 50%;
	border-radius: 50%;
	text-indent: -9999px;
	overflow: hidden;
	cursor: pointer;

	&.active {
		background-color: rgba($light-blue, 0.25);
		box-shadow: 0px 2px 7px rgba(144, 125, 213, 0.25);
	}
}
</style>
